import React from 'react';

const getInitials = (name) => {
    if (!name || typeof name !== 'string') return '?';
    const names = name.split(' ');
    const initials = names.map(n => n[0]).join('');
    return initials.substring(0, 2).toUpperCase();
};

const ClientChatCard = ({ chat, user, onClick }) => {
    const otherParticipantId = chat.participants?.find(p => p !== user?.uid);
    const otherParticipant = otherParticipantId ? chat.participantDetails?.[otherParticipantId] : null;

    const displayName = otherParticipant?.name || 'Usuário';
    const displayPhoto = otherParticipant?.photoUrl;
    const lastMessage = chat.lastMessage || 'Nenhuma mensagem ainda.';

    return (
        <div onClick={onClick} className="flex items-center p-2 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors border-b border-gray-50 last:border-0">
            {/* CONTAINER SQUIRCLE */}
            <div className="w-12 h-12 rounded-xl bg-white flex-shrink-0 mr-3 relative border border-gray-100 shadow-sm overflow-hidden flex items-center justify-center p-0.5">
                {displayPhoto ? (
                    <img src={displayPhoto} alt={displayName} className="w-full h-full object-contain rounded-lg" />
                ) : (
                    <div className="w-full h-full flex items-center justify-center rounded-lg bg-blue-500 text-white font-bold text-sm">
                        {getInitials(displayName)}
                    </div>
                )}
            </div>
            <div className="flex-grow truncate min-w-0">
                <p className="font-bold text-gray-800 text-sm truncate">{displayName}</p>
                <p className="text-xs text-gray-500 truncate">{lastMessage}</p>
            </div>
        </div>
    );
};

export default ClientChatCard;
